import { createSelector } from 'reselect';
import ThresholdsForCertificationSummaryColumns from '../../containers/ThresholdsForCertificationSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.THRESHOLDS_FOR_CERTIFICATION_545_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, ThresholdsForCertificationSummaryColumns);
